import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=827f724a&"
import script from "./Live.vue?vue&type=script&lang=js&"
export * from "./Live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports